"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStyle = void 0;
const typestyle_1 = require("typestyle");
const rootStyle = () => ({
    position: 'relative',
    color: 'white',
    width: '100%',
    height: '100%',
    cursor: 'none',
    userSelect: 'none'
});
const titleStyle = () => ({
    position: 'absolute',
    top: '50px',
    left: '12px',
    zIndex: 20,
    padding: '6px 10px',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    fontSize: '13pt',
    fontFamily: `'Roboto', Arial, Helvetica, sans-serif`,
    opacity: 0,
    transition: 'opacity 0.2s'
});
const controlsStyle = () => ({
    zIndex: 30,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    padding: '0 16px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    userSelect: 'none',
    opacity: 0,
    transition: 'opacity 0.2s'
});
exports.RootStyle = (0, typestyle_1.stylesheet)({
    root: Object.assign({}, rootStyle()),
    rootVisible: Object.assign(Object.assign({}, rootStyle()), { cursor: 'default' }),
    title: Object.assign({}, titleStyle()),
    titleVisible: Object.assign(Object.assign({}, titleStyle()), { opacity: 1 }),
    keysVisible: {
        pointerEvents: 'none',
        position: 'absolute',
        top: '70%',
        left: '50%',
        zIndex: 20,
        color: 'rgba(50, 130, 255, 1.0)',
        fontSize: '12pt',
        fontWeight: 'bold',
        fontFamily: `'Roboto', Arial, Helvetica, sans-serif`,
        opacity: 1,
        transition: 'opacity 0.2s',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center'
    },
    modelVisible: {
        pointerEvents: 'none',
        position: 'absolute',
        left: '50%',
        bottom: 0,
        width: '65%',
        zIndex: 11,
        opacity: 1,
        transform: 'translate(-50%, 0%)',
    },
    controls: Object.assign({}, controlsStyle()),
    controlsVisible: Object.assign(Object.assign({}, controlsStyle()), { opacity: 1 }),
    screen: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10
    }
});
